import { Injectable } from '@angular/core';
import { LoggingService } from '../../logging/logic/logging.service';
import { ActionHandler, ActionHandlerType } from '../action-handler';
import { NavController } from '@ionic/angular';
import { AlertService } from '../../alert/alert.service';
import { RemoteActionBuilderService } from '../../remote-action-builder/remote-action-builder.service';
import { TourEndRemoteActionBuilder } from 'src/app/_model/remote-action/remote-action-builder/tour-end-remote-action-builder/tour-end-remoteaction-builder';
import { TourService } from '../../tour/logic/tour.service';
import { ClientStateService } from '../../client-state/logic/client-state.service';
import { AppService } from '../../app-service/logic/app.service';
import { CredentialsService } from '../../credentials/logic/credentials.service';
import { LocationService } from '../../location/location.service';
import { RemoteActionService } from '../../remote-action/logic/remote-action.service';
import { NavigationOptions } from '@ionic/angular/common/providers/nav-controller';
import { Tour } from 'src/app/_model/tour';
import { ServicejobsService } from '../../servicejobs/logic/servicejobs.service';
import { ServicejobStatus } from 'src/app/_model/servicejob';
import { TranslateService } from '@ngx-translate/core';
import { AppParameterService } from '../../app-parameter/logic/app-parameter.service';
import {
  RequiredUserActionLevel,
  RequiredUserActionValidatorService,
} from '../../user-action-validator/required-user-action-validator.service';
import { GPSTrackService } from '../../gps-track/gps-track.service';
import { PeripheralsService } from '../../peripherals/logic/peripherals.service';

@Injectable({
  providedIn: 'root',
})
export class FinishTourActionHandler implements ActionHandler {
  // Public Member
  public readonly name: ActionHandlerType = 'finishtour';

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private translate: TranslateService,
    private alertService: AlertService,
    private remoteActionBuilderService: RemoteActionBuilderService,
    private tourService: TourService,
    private servicejobsService: ServicejobsService,
    private clientStateService: ClientStateService,
    private appService: AppService,
    private credentialService: CredentialsService,
    private locationService: LocationService,
    private remoteActionService: RemoteActionService,
    private navigationController: NavController,
    private appParameterService: AppParameterService,
    private gpsTrackService: GPSTrackService,
    private requiredUserActionValidator: RequiredUserActionValidatorService,
    private peripheralService: PeripheralsService
  ) {}

  // ActionHandler
  public async executeAction(params?: any): Promise<any> {
    const canExecute = await this.requiredUserActionValidator.triggerLevel(
      RequiredUserActionLevel.END_TOUR
    );

    if (!canExecute) {
      return;
    }

    this.logger.log(this.constructor.name, 'execute Action', this.name);
    let tourId = this.clientStateService.theState.getValue().tourId;
    let tour = this.tourService.getTourById(tourId);

    if (tour == undefined) {
      this.logger.warn(
        this.constructor.name,
        'attempted to finish tour while no tour is available'
      );
      return;
    }

    let sjobs = this.servicejobsService.getServiceJobsForTourId(tourId);

    let hasOpenJobs = sjobs
      .map((job) => job.status < ServicejobStatus.STATUS_FINISHED)
      .reduce((prev, cur) => prev || cur, false);
    if (hasOpenJobs) {
      this.alertService.showAlert(
        this.translate.instant('ACTION.FINISH-TOUR.OPEN-STOPS.ALERT.TITLE'),
        undefined,
        this.translate.instant('ACTION.FINISH-TOUR.OPEN-STOPS.ALERT.MESSAGE'),
        this.translate.instant('ACTION.FINISH-TOUR.OPEN-STOPS.ALERT.CONTINUE'),
        async () => {
          await this.finishTour(tour);
        },
        undefined,
        undefined,
        true,
        'danger'
      );
    } else {
      await this.finishTour(tour);
    }
  }

  // Private Functions

  private async finishTour(tour: Tour) {
    this.remoteActionBuilderService.newBuild(
      new TourEndRemoteActionBuilder(
        tour,
        [],
        this.appService,
        this.credentialService,
        this.locationService,
        this.clientStateService,
        this.tourService,
        this.remoteActionService,
        this.appParameterService,
        this.gpsTrackService,
        this.logger
      )
    );
    let navOptions: NavigationOptions = {
      queryParams: {
        customBackUrl: 'tabbar/mainMenu',
      },
    };
    this.navigationController.navigateForward(
      '/feature/remote-action',
      navOptions
    );

    this.logger.log(
      this.constructor.name,
      'finish tour - needs balance:',
      tour.cardPaymentDone
    );
    if (tour.cardPaymentDone) {
      await this.peripheralService.doBalance();
    }
  }
}
